import React from 'react';
import clsx from 'clsx';
import themePrimary from '../../styles/themePrimary';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { Skin } from '../../models/common/Skin';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';

const useStyles = makeStyles({
    button: {
        height: '60px',
        width: 'calc(100vw *.3)',
        marginLeft: '4px',
        marginRight: '4px',
        borderRadius: '10px',
        float: 'left',
        padding: '3px',
        textAlign: 'center',
        color: themePrimary.palette.secondary.contrastText,  
        border: props => '3px solid ' + (props as Skin).primary_main_color,      
    },
    buttonSelected: {
        height: '60px',
        width: 'calc(100vw *.3)',
        marginLeft: '4px',
        marginRight: '4px',
        borderRadius: '10px',
        float: 'left',
        padding: '3px',
        textAlign: 'center',
        color: themePrimary.palette.primary.contrastText,  
        backgroundColor:  props => (props as Skin).primary_main_color,  
    },
    buttonTextAmount: {
        fontSize: '1.1em',
        lineHeight: '1.1em',
        verticalAlign: 'middle',
        color: themePrimary.palette.secondary.contrastText, 
    },
    buttonTextAmountSelected: {
        fontSize: '1.1em',
        lineHeight: '1.1em',
        verticalAlign: 'middle',
        color: themePrimary.palette.primary.contrastText,
    },
    buttonTextPercent: {
        fontSize: '1.4em',
        lineHeight: '1.2em',
        verticalAlign: 'middle',
        color: themePrimary.palette.secondary.contrastText, 
    },
    buttonTextPercentSelected: {
        fontSize: '1.4em',
        lineHeight: '1.2em',
        verticalAlign: 'middle',
        color: themePrimary.palette.primary.contrastText,
    },
    buttonInternalContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    buttonTextContainer: {
        marginTop: '-2px',
    },
});

const TipButtonInternal = withStyles((themePrimary) => ({
  root: {
    borderRadius: '50px',
    boxShadow: 'none',
    fontSize: themePrimary.typography.h4.fontSize,
    width: '100%',
    height: '100%',
  },
  label: {
      fontSize: '1rem',
  }
}))(IconButton);

export type TipButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface TipButtonProps {
    amount: String,
    percentage: Number,
    selected: Boolean,
    onClickHandler: TipButtonClickHandler,
}

export default function TipButton(props: TipButtonProps) {
    const { amount, percentage, selected, onClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    return (
        <div className={clsx({
                [classes.buttonSelected]: selected,
                [classes.button]: !selected,
            })}>
            <TipButtonInternal
                onClick={onClickHandler}
                className={classes.buttonInternalContainer}>
                <div>
                    <div className={classes.buttonTextContainer}>
                        <span className={clsx({
                            [classes.buttonTextPercentSelected]: selected,
                            [classes.buttonTextPercent]: !selected,
                        })}>{percentage.toString() + "%"}</span>
                    </div>
                    <div className={classes.buttonTextContainer}>
                        <span className={clsx({
                            [classes.buttonTextAmountSelected]: selected,
                            [classes.buttonTextAmount]: !selected,
                        })}>${amount.toString()}</span>
                    </div>
                </div>
            </TipButtonInternal>
        </div>
            
    );
}